<div class="footer-wrapper">
  <!--first row-->
  <div class="first-row">
    <div>
      <img
        src="assets/shared/global-images/payee-logos/v1/white-payee-with-badge.svg"
        width="100px"
        height="41px"
        alt="Payee"
      />
    </div>
    <div class="first-row-second-column">
      <a
        href="https://payee.tech/about"
        target="_blank"
      >
        <payee-icon
          class="link-icon"
          height="20px"
          [name]="'external-link-white'"
        ></payee-icon>
        <span>{{ "FOOTER.WHO_ARE_WE" | translate }}</span>
      </a>
      <a
        href="https://help.payee.tech/hu/articles/6583276-ugyvedi-partnereink"
        target="_blank"
      >
        <payee-icon
          class="link-icon"
          height="20px"
          [name]="'external-link-white'"
        ></payee-icon>
        <span>{{ "FOOTER.ATTORNEY" | translate }}</span>
      </a>
      <a
        href="https://help.payee.tech/hu/articles/6228843-a-payee-mukodesenek-jogi-alapjai"
        target="_blank"
      >
        <payee-icon
          class="link-icon"
          height="20px"
          [name]="'external-link-white'"
        ></payee-icon>
        <span>{{ "FOOTER.LEGAL_BACKGROUND" | translate }}</span>
      </a>
      <a
        href="https://payee.tech/contact"
        target="_blank"
      >
        <payee-icon
          class="link-icon"
          height="20px"
          [name]="'external-link-white'"
        ></payee-icon>
        <span>{{ "FOOTER.CONTACT" | translate }}</span>
      </a>
      <div class="separator-line"></div>
      <img
        class="flag"
        src="assets/shared/global-images/flags/HU.svg"
        alt="Hungary"
      />
    </div>
  </div>

  <!--second row-->
  <div class="second-row">
    {{ "FOOTER.MISSION_STATEMENT" | translate }}
  </div>

  <!--third row-->
  <div class="third-row">
    <payee-icon
      [name]="'gdpr'"
      [height]="'40px'"
      [width]="'106px'"
    ></payee-icon>
    <payee-icon
      class="ssl-icon"
      [name]="'ssl'"
      [height]="'40px'"
      [width]="'93px'"
    ></payee-icon>
  </div>

  <!--fourth row-->
  <div class="fourth-row">
    <div class="fourth-row-first-column">
      {{ "FOOTER.COPYRIGHT" | translate: { year: currentYear } }}
    </div>
    <div class="fourth-row-second-column">
      <a
        href="https://www.payee.tech/legal/terms-and-conditions"
        target="_blank"
      >
        {{ "FOOTER.TOS" | translate }}
      </a>
      <a
        href="https://www.payee.tech/legal/privacy-policy"
        target="_blank"
        class="middle-link"
      >
        {{ "FOOTER.PRIVACY" | translate }}
      </a>
      <a
        href="https://help.payee.tech/hu/articles/6228854-impresszum"
        target="_blank"
      >
        {{ "FOOTER.IMPRINT" | translate }}
      </a>
    </div>
  </div>
</div>
